import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FlyoutDataType, FlyoutOpeningData } from '../flyout-models';

@Component({
  selector: 'app-flyout-star-scoring',
  templateUrl: './flyout-star-scoring.component.html',
  styleUrls: ['./flyout-star-scoring.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutStarScoringComponent {
  private _commitment = undefined;
  public _score = 0;
  public _flyoutDataType: FlyoutDataType;
  public flyoutDataSubType: string;
  public flyoutDataType = FlyoutDataType;
  public scaledScore = 0;
  public emptyStars = 7;

  @Input() set flyoutData(flyoutData: FlyoutOpeningData) {
    this._flyoutDataType = flyoutData.type;
    this.flyoutDataSubType = flyoutData.subType;
    this.recalculateScoringStars();
  }

  @Input() set score(score: number) {
    this._score = score;
    this.recalculateScoringStars();
  }

  @Input() public set commitment(commitment: number) {
    this._commitment = commitment;
    this.recalculateScoringStars();
  }
  public get commitment(): number {
    return this._commitment;
  }

  constructor() {}

  private recalculateScoringStars() {
    this.emptyStars = 7 - this._commitment;
  }
}
